/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { StyleSheet, Pressable } from 'react-native';
import Image from '@web/components/common/Image';
import Input from '../Input';
import Colors from '~global/Colors';
import { isNative } from '~global/screens';

const InputPassword = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [inputRef, setInputRef] = useState(null);
  //const [showFakePassword, setShowFakePassword] = useState(true);
  const iconReveal = showPassword
    ? require('~assets/img/common/reveal-show.png')
    : require('~assets/img/common/reveal-hide.png');
  const handleShowPassword = () => {
    setShowPassword(!showPassword);
    //setShowFakePassword(!showFakePassword);
  };

  const onFocus = () => {
    inputRef?.focus();
  };

  const onChangeText = (val) => {
    //const showPwd = showFakePassword;
    //const hide = Boolean(val && val.length > 1);
    // if (hide) {
    //   setInputRef(null);
    // }
    //const hide = Boolean(val);
    // setShowFakePassword(!hide);
    // if (showPwd === false && hide === false) {
    //   setTimeout(() => {
    //     onFocus();
    //   }, 500);
    // }
    props.onChangeText(val);
  };

  const customStyle = {
    realInputPassword: {
      backgroundColor: Colors.transparent,
      //borderColor: Colors.transparent,
    },
    fakeInputContainer: {
      marginTop: -49,
      zIndex: -1,
      elevation: -1,
      borderColor: Colors.transparent,
      color: Colors.transparent,
    },
    fakeInput: {
      color: Colors.transparent,
      ...(!isNative
        ? {
            caretColor: Colors.black0,
            letterSpacing: 1,
          }
        : {}),
    },
  };

  return (
    <>
      <Input
        {...props}
        secureTextEntry={!showPassword}
        //onFocus={() => onFocus()}
        onChangeText={(val) => onChangeText(val)}
        containerStyle={customStyle.realInputPassword}
        inputContainerStyle={customStyle.realInputPassword}
        style={customStyle.realInputPassword}
        rightIcon={
          <Pressable onPress={handleShowPassword}>
            <Image style={styles.icon} source={iconReveal} />
          </Pressable>
        }
      />
      {/* {showFakePassword && (
        <Input
          {...props}
          containerStyle={customStyle.fakeInputContainer}
          inputContainerStyle={customStyle.fakeInput}
          style={customStyle.fakeInput}
          label=""
          inputRef={(ref) => setInputRef(ref)}
          onChangeText={(val) => onChangeText(val)}
        />
      )} */}
    </>
  );
};

const styles = StyleSheet.create({
  icon: {
    width: 23,
    height: 14,
  },
});

export default InputPassword;
